import React from "react";
// @ts-ignore
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { ListGroup, ListGroupItem } from "components/Shared";
import { translate } from "lib";
import ReactDOM from "react-dom";

// Helper function to properly merge styles for dragging
const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
  userSelect: "none",
  background: isDragging ? "#f0f0f0" : "transparent",
  ...draggableStyle
});

// Portal for rendering the dragged item outside modal boundaries
const portal: HTMLElement = document.createElement('div');
document.body.appendChild(portal);

export default class DraggableConditions extends React.Component {
  constructor(props: any) {
    super(props);
    this.state = {
      conditions: props.conditions
    };
  }

  UNSAFE_componentWillReceiveProps(props: any) {
    this.setState({ conditions: props.conditions });
  }

  onDragEnd = (result: any) => {
    if (!result.destination) {
      return;
    }

    const { onUpdate } = this.props as any;
    const { conditions } = this.state as { conditions: any[] };
    
    const reorderedConditions = Array.from(conditions);
    const [removed] = reorderedConditions.splice(result.source.index, 1);
    reorderedConditions.splice(result.destination.index, 0, removed);

    const conditionsWithNewIndex = reorderedConditions.map((condition: any, index: number) => ({
      ...condition,
      index: index
    }));

    this.setState({ conditions: conditionsWithNewIndex }, () => onUpdate(conditionsWithNewIndex));
  };

  handleRemove = (conditionId: string) => {
    const { onUpdate } = this.props as any;
    const { conditions } = this.state as { conditions: any[] };
    const updatedConditions = conditions.filter(c => c.id !== conditionId);
    this.setState({ conditions: updatedConditions }, () => onUpdate(updatedConditions));
  };

  render() {
    const { onAdd } = this.props as any;
    const { conditions } = this.state as { conditions: any[] };

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="conditions-droppable">
          {(provided: any, snapshot: any) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{
                background: snapshot.isDraggingOver ? 'rgba(0, 123, 255, 0.05)' : 'transparent',
              }}
            >
              <ListGroup
                resource="conditions"
                collection={conditions}
                pagination={false}
                onAdd={onAdd}
                renderRow={(condition: any) => (
                  <Draggable 
                    key={condition.id} 
                    draggableId={condition.id} 
                    index={conditions.indexOf(condition)}
                  >
                    {(provided: any, snapshot: any) => {
                      const child = (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style
                          )}
                        >
                          <ListGroupItem
                            key={condition.id}
                            title={translate(condition.kind)}
                            heading={condition.name}
                            onRemove={() => this.handleRemove(condition.id)}
                          />
                        </div>
                      );

                      // Render dragging item in a portal to escape modal overflow constraints
                      if (snapshot.isDragging) {
                        return ReactDOM.createPortal(child, portal);
                      }
                      return child;
                    }}
                  </Draggable>
                )}
              />
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    );
  }
}